import React, { Fragment } from 'react';
import styled from 'styled-components';

import ConfigControl from '../../../components/ConfigControl';
import { MonitorConfig } from '../../../helpers/constants';
import { colors } from '../WindowConfig';
import Cell from './common/Cell';
import Column from './common/Column';
import DataCell from './common/DataCell';
import Row from './common/Row';
import UnitContainer from './common/UnitContainer';
import MonitorField from './common/MonitorField';
import MonitorLabel from './common/MonitorLabel';
import LongStyledButton from './common/LongStyledButton';

export interface IShipInfoAreaProps {
  currentConfig: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const RowContainer = styled(Row)`
  flex-direction: row;
`;
const Label = styled.div`
  display: inline-block;
  width: 50px;
`;

export default function ShipInfoArea({ currentConfig }: IShipInfoAreaProps) {
  return (
    <Fragment>
      <ConfigControl elementFor={MonitorConfig.SONAR} config={currentConfig}>
        <Container>
          <RowContainer>
            <MonitorLabel style={{ width: '50px' }} field="ship-info-area-1" />
            <DataCell className="container" width="30%">
              <MonitorField field="ship-info-area-1" />
            </DataCell>
            <UnitContainer field="ship-info-area-1" />
          </RowContainer>
          <RowContainer>
            <MonitorLabel style={{ width: '50px' }} field="ship-info-area-2" />
            <DataCell className="inputField" width="30%">
              <MonitorField field="ship-info-area-2" />
            </DataCell>
            <UnitContainer field="ship-info-area-2" />
          </RowContainer>
          <RowContainer>
            <MonitorLabel style={{ width: '50px' }} field="ship-info-area-3" />
            <DataCell className="inputField" width="30%">
              <MonitorField field="ship-info-area-3" />
            </DataCell>
            <UnitContainer field="ship-info-area-3" />
          </RowContainer>
          <RowContainer>
            <MonitorLabel style={{ width: '50px' }} field="ship-info-area-4" />
            <DataCell className="inputField" width="30%">
              <MonitorField field="ship-info-area-4" />
            </DataCell>
            <UnitContainer field="ship-info-area-4" />
          </RowContainer>
        </Container>
      </ConfigControl>
      <ConfigControl
        elementFor={[
          MonitorConfig.TACTICO,
          MonitorConfig.SISTEMA,
          MonitorConfig.OBT,
        ]}
        config={currentConfig}
      >
        <RowContainer>
          <Column width="55%">
            <Row>
              <MonitorLabel style={{ width: '40%' }} field="ship-info-area-1" />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-1" />
              </DataCell>
              <UnitContainer field="ship-info-area-1" />
            </Row>
            <Row>
              <MonitorLabel style={{ width: '40%' }} field="ship-info-area-2" />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-2" />
              </DataCell>
              <UnitContainer field="ship-info-area-2" />
            </Row>
            <Row>
              <MonitorLabel style={{ width: '40%' }} field="ship-info-area-3" />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-3" />
              </DataCell>
              <UnitContainer field="ship-info-area-3" />
            </Row>
            <Row>
              <MonitorLabel style={{ width: '40%' }} field="ship-info-area-4" />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-4" />
              </DataCell>
              <UnitContainer field="ship-info-area-4" />
            </Row>
          </Column>
          <Column width="45%">
            <RowContainer>
              <MonitorLabel style={{ width: '40%' }} field="ship-info-area-5" />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-5" />
              </DataCell>
              <UnitContainer field="ship-info-area-5" />
            </RowContainer>
            <RowContainer>
              <MonitorLabel style={{ width: '40%' }} field="ship-info-area-6" />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-6" />
              </DataCell>
              <UnitContainer field="ship-info-area-6" />
            </RowContainer>
            <RowContainer>
              <MonitorLabel style={{ width: '40%' }} field="ship-info-area-7" />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-7" />
              </DataCell>
              <UnitContainer field="ship-info-area-7" />
            </RowContainer>
            <RowContainer>
              <MonitorLabel style={{ width: '40%' }} field="ship-info-area-8" />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-8" />
              </DataCell>
              <UnitContainer field="ship-info-area-8" />
            </RowContainer>
          </Column>
        </RowContainer>
      </ConfigControl>
      <ConfigControl elementFor={MonitorConfig.WEAPON} config={currentConfig}>
        <RowContainer>
          <Column width="20%">
            <Row>
              <MonitorLabel style={{ width: '40%' }} field="ship-info-area-1" />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-1" />
              </DataCell>
              <UnitContainer field="ship-info-area-1" />
            </Row>
            <Row>
              <MonitorLabel style={{ width: '40%' }} field="ship-info-area-2" />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-2" />
              </DataCell>
              <UnitContainer field="ship-info-area-2" />
            </Row>
            <Row>
              <MonitorLabel style={{ width: '40%' }} field="ship-info-area-3" />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-3" />
              </DataCell>
              <UnitContainer field="ship-info-area-3" />
            </Row>
            <Row>
              <MonitorLabel style={{ width: '40%' }} field="ship-info-area-4" />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-4" />
              </DataCell>
              <UnitContainer field="ship-info-area-4" />
            </Row>
          </Column>
          <Column width="30%">
            <Row>
              <DataCell width="99%">
                <LongStyledButton
                  field="ship-info-area-5"
                  endWithColon={false}
                  style={{ width: '99%' }}
                />
              </DataCell>
            </Row>
            <Row>
              <DataCell width="99%">
                <LongStyledButton
                  field="ship-info-area-6"
                  endWithColon={false}
                  style={{ width: '99%' }}
                />
              </DataCell>
            </Row>
            <Row>
              <DataCell width="99%">
                <LongStyledButton
                  field="ship-info-area-7"
                  endWithColon={false}
                  style={{ width: '99%' }}
                />
              </DataCell>
            </Row>
            <Row>
              <DataCell width="99%">
                <LongStyledButton
                  field="ship-info-area-8"
                  endWithColon={false}
                  style={{ width: '99%' }}
                />
              </DataCell>
            </Row>
          </Column>
          <Column width="20%">
            <Row>
              <MonitorLabel style={{ width: '36%' }} field="ship-info-area-9" />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-9" />
              </DataCell>
              <UnitContainer field="ship-info-area-9" />
            </Row>
            <Row>
              <MonitorLabel
                style={{ width: '36%' }}
                field="ship-info-area-10"
              />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-10" />
              </DataCell>
              <UnitContainer field="ship-info-area-10" />
            </Row>
            <Row>
              <MonitorLabel
                style={{ width: '36%' }}
                field="ship-info-area-11"
              />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-11" />
              </DataCell>
              <UnitContainer field="ship-info-area-11" />
            </Row>
            <Row>
              <MonitorLabel
                style={{ width: '36%' }}
                field="ship-info-area-12"
              />
              <DataCell width="46%">
                <MonitorField field="ship-info-area-12" />
              </DataCell>
              <UnitContainer field="ship-info-area-12" />
            </Row>
          </Column>
          <Column width="30%">
            <Row>
              <DataCell width="100%">
                <MonitorField field="ship-info-area-13" />
              </DataCell>
            </Row>
            <Row>
              <DataCell width="100%">
                <MonitorField field="ship-info-area-14" />
              </DataCell>
            </Row>
            <Row>
              <DataCell width="100%">
                <MonitorField field="ship-info-area-15" />
              </DataCell>
            </Row>
            <Row>
              <DataCell width="100%">
                <MonitorField field="ship-info-area-16" />
              </DataCell>
            </Row>
          </Column>
        </RowContainer>
      </ConfigControl>
    </Fragment>
  );
}
